import React, { useRef, useEffect, useCallback, useState} from 'react';
import PadComponent from "components/pads/PadComponent.js";
import {AUDIO_FX} from 'constants/effect-types.js';
import LiveEffectComponent from "components/effects/LiveEffectComponent.js";
import MidiEffectComponent from "components/effects/MidiEffectComponent.js";
import EffectComponent from "components/effects/EffectComponent.js";
import {connect} from 'react-redux';

/**
 * A module used in system 5 of the viable system model. 
 * It contains a handful of high interest data points
 * They will also allow patching between each other
 * to further guide how the system should play
 *
 * For now they will contain 4 quadrants:
     1. Stats
     2. Reduced Planar Parameters
     3. Trigger display (almost like a 90s tracker)
     4. A note display midi effect
     
     * These 4 will be choosable via "starring" an effect/module
     * meaning the user has chosen it to be important and to 
     * be shown in this reduced format
 */
const ModuleSys5 = ({showPads, effectStarred, subSequence}) => { 
    let ref = useRef(undefined);
    let {shadowEffects} = subSequence.midiEffects;
    const [starredEffects, setStarredEffects] = useState([]);
    
    useEffect(() => {
        let effects= [
            ...subSequence.getAllEffects()];
        const getEffects = (effects) => {
            let _effects = [];
            for (let effect of effects) {
                _effects.push(effect);
                if (effect.effects) {
                    _effects = [... _effects, ... effect.effects];
                }
            }
            return _effects;
        };
        for (let track of subSequence.tracks) {
            effects = [... effects, ...getEffects(track.effects),
                       ... getEffects(track.midiEffects.effects)];
        }
        
        setStarredEffects(effects.filter(e => effectStarred[e.id]));
    }, [setStarredEffects, effectStarred]);

    const getEffectComponent = (fx) => {
        if (fx.getEffectType() === AUDIO_FX) {
            return (<EffectComponent
                      showDelete={false}
                      isDraggable={false}
                      featured={true}
                      sequencerEngine={subSequence.sequencerEngine}
                      WIDTH={180}
                      HEIGHT={95}
                      track={fx.track}
                      compact={true}
                      instrument={true}
                      onDeleteEffect={() => []}
                      effect={fx}
                      send={undefined}/>);
        } else {
            return (<MidiEffectComponent
                  showDelete={false}
                  isDraggable={false}
                  featured={true}
                  sequencerEngine={subSequence.sequencerEngine}
                  WIDTH={180}
                  HEIGHT={95}
                  track={fx.track}
                  compact={true}
                  instrument={true}
                  onDeleteEffect={() => []}
                  effect={fx}
                  send={undefined}/>);
        }
    };

    let script = subSequence.midiEffects.effects.find(
        e => e.name === "User Script");

    return (
        <div ref={ref} className="module-inner">
          {/*
          <div className="module-row">
            <LiveEffectComponent
              showDelete={false}
              isDraggable={false}
              featured={true}
              sequencerEngine={subSequence.sequencerEngine}
              track={subSequence}
              compact={true}
              instrument={true}
              onDeleteEffect={() => []}
              effect={subSequence.playhead}
              send={undefined}/>
            {getEffectComponent(shadowEffects[0])}
          </div>
          <div className="module-row">
            {getEffectComponent(shadowEffects[1])}
            <div className="module-col">
              <div>
              {getEffectComponent(shadowEffects[2])}
              </div>
              <div>
              {showPads && subSequence.pads.map(
                  pad =>
                      <PadComponent
                        isPulled={true}
                        scrollContainer={ref}
                        pad={pad}/>)}
              </div>
            </div>
          </div>
           */}
          <div className="starred-effects">
            {starredEffects.map(
                e => getEffectComponent(e))}
          </div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      effectStarred: state.effects.effectStarred
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModuleSys5);
